import HELPERS from "utils/helper";
// const roleCode = HELPERS.getCookie(‘roleCode’);
const AUTH_API = {
  sendOTP: (params) => {
    return HELPERS.request({
      url: `signin`,
      method: "POST",
      data: params,
    });
  },
  requestAccess: (params) => {
    return HELPERS.request({
      url: `request-access`,
      method: "POST",
      data: params,
    });
  },
  verifyOTP: (params) => {
    return HELPERS.request({
      url: `verify`,
      method: "POST",
      data: params,
    });
  },
  registerUser: (params) => {
    return HELPERS.request({
      url: `register`,
      method: "POST",
      data: params,
    });
  },
  aboutYourself: (params) => {
    return HELPERS.secureRequest({
      url: `profile/aboutyourself/${HELPERS.getUserId()}/`,
      method: "PATCH",
      data: params,
    });
  },
  aboutYourselfGet: () => {
    return HELPERS.secureRequest({
      url: `profile/aboutyourself/`,
      method: "GET",
    });
  },
  ourCommitment: (params) => {
    return HELPERS.secureRequest({
      url: `profile/ourcommitmenttoyou/${HELPERS.getUserId()}/`,
      method: "PATCH",
      data: params,
    });
  },
  ourCommitmentGet: () => {
    return HELPERS.secureRequest({
      url: `profile/ourcommitmenttoyou/`,
      method: "GET",
    });
  },
  updateYourCommitment: (params) => {
    return HELPERS.secureRequest({
      url: `profile/yourcommitmenttoyourself/${HELPERS.getUserId()}/`,
      method: "PATCH",
      data: params,
    });
  },
  postFeedback: (data) => {
    return HELPERS.secureRequest({
      url: `feedback/${HELPERS.getUserId()}/`,
      method: "PATCH",
      data,
    });
  },
  getYourCommitment: () => {
    return HELPERS.secureRequest({
      url: `profile/yourcommitmenttoyourself/`,
      method: "GET",
    });
  },
  getAllTargetroles: () => {
    return HELPERS.secureRequest({
      url: `target/roles/`,
      method: "GET",
    });
  },
  getTargetrole: (id) => {
    return HELPERS.secureRequest({
      url: `target/roles/`,
      method: "GET",
    });
  },
  addTargetrole: (params, Stepname) => {
    return HELPERS.secureRequest({
      url: `target/roles/`,
      method: "POST",
      data: params,
      Stepname,
    });
  },
  targetRolesPatch: (params, id, Stepname) => {
    return HELPERS.secureRequest({
      url: `target/roles/` + id + `/`,
      method: "PATCH",
      data: params,
      Stepname,
    });
  },
  targetRolesDelete: (id, Stepname) => {
    return HELPERS.secureRequest({
      url: `target/roles/` + id + `/`,
      method: "DELETE",
      Stepname,
      // data: params,
    });
  },
  getAllTargetindustries: () => {
    return HELPERS.secureRequest({
      url: `target/industries/`,
      method: "GET",
    });
  },
  getTargetindustry: (id) => {
    return HELPERS.secureRequest({
      url: `target/industries/`,
      method: "GET",
    });
  },
  setTargetindustry: (params, Stepname) => {
    return HELPERS.secureRequest({
      url: `target/industries/`,
      method: "POST",
      data: params,
      Stepname,
    });
  },
  targetIndustriesPatch: (params, id, Stepname) => {
    return HELPERS.secureRequest({
      url: `target/industries/` + id + `/`,
      method: "PATCH",
      data: params,
      Stepname,
    });
  },
  targetIndustriesDelete: (id) => {
    return HELPERS.secureRequest({
      url: `target/industries/` + id + `/`,
      method: "DELETE",
      // data: params,
    });
  },
  getEditorData: (id) => {
    return HELPERS.secureRequest({
      url: `patch-editor/` + id + `/`,
      method: "GET",
      // data: parmas
    });
  },
  /*getEditorData: async (id) => {
    const data = {
      data: {
        // editor_data: '<p>Hello <strong>Worldd</strong> fsd <span style="text-decoration: underline;">fsdf</span> sd f</p><table style="border-collapse: collapse; width: 100%; height: 66px;" border="1"><tbody><tr style="height: 22px;"><td style="width: 24.1245%; height: 22px;">sfdsfsd</td><td style="width: 24.1245%; height: 22px;">&nbsp;</td><td style="width: 24.1245%; height: 22px;">&nbsp;</td><td style="width: 24.1245%; height: 22px;">&nbsp;</td></tr><tr style="height: 22px;"><td style="width: 24.1245%; height: 22px;"><h2><em><strong>sdfsdfsdsdf</strong></em></h2></td><td style="width: 24.1245%; height: 22px;">sdfsdf</td><td style="width: 24.1245%; height: 22px;">&nbsp;</td><td style="width: 24.1245%; height: 22px;">&nbsp;</td></tr><tr style="height: 22px;"><td style="width: 24.1245%; height: 22px;">&nbsp;</td><td style="width: 24.1245%; height: 22px;">sdfsdf</td><td style="width: 24.1245%; height: 22px;"><h3><em><span style="text-decoration: underline;">sdfsdfsdf</span></em></h3></td><td style="width: 24.1245%; height: 22px;">sdfsdfsdf</td></tr></tbody></table>'
        editor_data: 'Hello World'
      }
    };
    return data;
  },
  */
  // patchTextEditor: (params, id) => {
  //   return HELPERS.secureRequest({
  //     url: `textditor/` + id + `/`,
  //     method: "PATCH",
  //     data: params,
  //   });
  // },
  /*patchTextEditor: async (parmas) => {
    const data = {
      data: {
        editor_data: parmas.editor_data,
        stepId: parmas.stepId
      }
    };
    return data;
  },*/
  patchTextEditor: (params) => {
    return HELPERS.request({
      url: `patch-editor`,
      method: "POST",
      data: params,
    });
  },
  getAllTargetworkenvironment: () => {
    return HELPERS.secureRequest({
      url: `target/workenvironments/`,  
      method: "GET",
    });
  },
  // getAllTargetworkenvironment: () => {
  //   return Promise.resolve({
  //     data: [
  //       {
  //         additional_questions: [],
  //         client: 574,
  //         id: 14201,
  //         learn_more: true,
  //         priority: 0,
  //         reflections: [],
  //         research_questions: [],
  //         selected_for: [0],
  //         title: "Enter Criteria",
  //       },
  //       {
  //         additional_questions: [],
  //         client: 574,
  //         id: 14190,
  //         learn_more: true,
  //         priority: 1,
  //         reflections: [],
  //         research_questions: [],
  //         selected_for: [],
  //         title: "Enter Criteria",
  //       },
  //       {
  //         additional_questions: [],
  //         client: 574,
  //         id: 12123,
  //         learn_more: true,
  //         priority: 2,
  //         reflections: [],
  //         research_questions: [],
  //         selected_for: [],
  //         title: "Enter Criteria",
  //       }
  //     ]
  //   });
  // },
  getNotification: (user_id) => {
    return HELPERS.secureRequest({
      url: `notification/${HELPERS.getUserId()}`,
      method: "GET",
      data: {user_id},
    });
  },
  patchNotification: (user_id, id, item) => {
    return HELPERS.secureRequest({
      url: `notification/${HELPERS.getUserId()}/`,
      method: "PATCH",
      data: {user_id, item, id},
    });
  },
  searchResults: (user_id, query) => {
    return HELPERS.secureRequest({
      url: `searchresults/${HELPERS.getUserId()}/?query=${encodeURIComponent(query)}`,
      method: "GET",
      data: {user_id, query},
    });
  },
  getTargetworkenvironment: (id) => {
    return HELPERS.secureRequest({
      url: `target/workenvironments/`,
      method: "GET",
    });
  },
  setTargetworkenvironment: (params, Stepname) => {
    return HELPERS.secureRequest({
      url: `target/workenvironments/`,
      method: "POST",
      data: params,
      Stepname,
    });
  },
  targetWorkEnvironmentsPatch: (params, id, Stepname) => {
    return HELPERS.secureRequest({
      url: `target/workenvironments/` + id + `/`,
      method: "PATCH",
      data: params,
      Stepname,
    });
  },
  targetWolkEnvironmentsDelete: (id) => {
    return HELPERS.secureRequest({
      url: `target/workenvironments/` + id + `/`,
      method: "DELETE",
      // data: params,
    });
  },
  getAllContacts: () => {
    return HELPERS.secureRequest({
      url: `contacts/`,
      method: "GET",
    });
  },
  getContact: (id) => {
    return HELPERS.secureRequest({
      url: `contacts/` + id + `/`,
      method: "GET",
    });
  },
  setNewContact: (params, Stepname) => {
    return HELPERS.secureRequest({
      url: `contacts/`,
      method: "POST",
      data: params,
      Stepname,
    });
  },
  patchContact: (params, id, Stepname) => {
    return HELPERS.secureRequest({
      url: `contacts/` + id + `/`,
      method: "PATCH",
      data: params,
      Stepname,
    });
  },
  deleteContact: (id, Stepname) => {
    return HELPERS.secureRequest({
      url: `contacts/` + id + `/`,
      method: "DELETE",
      Stepname,
      // data: params,
    });
  },
  patchReflectionsProcess: (params, id, Stepname) => {
    return HELPERS.secureRequest({
      url: `reflectionsprocess/` + id + `/`,
      method: "PATCH",
      data: params,
      Stepname,
    });
  },
  CoachListView: () => {
    return HELPERS.secureRequest({
      url: `coachlistview/`,
      method: "GET",
    });
  },
  CoachListViewLoadMoreData: (page) => {
    return HELPERS.secureRequest({
      url: `coachlistview/?page=` + page,
      method: "GET",
    });
  },
  CoachStepsPatch: (params, id) => {
    return HELPERS.secureRequest({
      url: `stepreflection/` + id + `/setstepstatus/`,
      method: "PATCH",
      data: params,
    });
  },
  CoachListPatch: (params, id) => {
    return HELPERS.secureRequest({
      url: `coachlistview/` + id + `/setuserdetails/`,
      method: "PATCH",
      data: params,
    });
  },
  postAssessment: (params) => {
    return HELPERS.secureRequest({
      url: `assessment/`,
      method: "POST",
      data: params,
    });
  },
  getAssessment: () => {
    return HELPERS.secureRequest({
      url: `assessment/`,
      method: "GET",
    });
  },
  patchAssessment: (params, id) => {
    return HELPERS.secureRequest({
      url: `assessment/` + id + `/`,
      method: "PATCH",
      data: params,
    });
  },
  getAllEmailDrafts: () => {
    return HELPERS.secureRequest({
      url: `emaildraft/`,
      method: "GET",
    });
  },
  patchEmailDrafts: (params, id) => {
    return HELPERS.secureRequest({
      url: `emaildraft/` + id + `/`,
      method: "PATCH",
      data: params,
    });
  },
  postEmailDraft: (params) => {
    return HELPERS.secureRequest({
      url: `emaildraft/`,
      method: "POST",
      data: params,
    });
  },
  deleteEmailDraft: (id) => {
    return HELPERS.secureRequest({
      url: `emaildraft/` + id + `/`,
      method: "DELETE",
    });
  },
  postMaterials: (params) => {
    return HELPERS.secureRequest({
      url: `materials/`,
      method: "POST",
      data: params,
    });
  },
  getMaterials: () => {
    return HELPERS.secureRequest({
      url: `materials/`,
      method: "GET",
    });
  },
  patchMaterials: (params, id, Stepname) => {
    return HELPERS.secureRequest({
      url: `materials/` + id + "/",
      method: "PATCH",
      data: params,
      Stepname,
    });
  },
  getAllCompanies: () => {
    return HELPERS.secureRequest({
      url: `company/`,
      method: "GET",
    });
  },
  getCompany: (id) => {
    return HELPERS.secureRequest({
      url: `company/` + id,
      method: "GET",
    });
  },
  patchCompany: (params, id, Stepname) => {
    return HELPERS.secureRequest({
      url: `company/` + id + "/",
      method: "PATCH",
      data: params,
      Stepname,
    });
  },
  postCompany: (params) => {
    return HELPERS.secureRequest({
      url: `company/`,
      method: "POST",
      data: params,
    });
  },

  deleteCompany: (id) => {
    return HELPERS.secureRequest({
      url: `company/` + id + "/",
      method: "DELETE",
    });
  },

  getLearning: () => {
    return HELPERS.secureRequest({
      url: `learning/`,
      method: "GET",
    });
  },
  postLearning: (params) => {
    return HELPERS.secureRequest({
      url: `learning/`,
      method: "POST",
      data: params,
    });
  },
  patchLearning: (params, id) => {
    return HELPERS.secureRequest({
      url: `learning/` + id + `/`,
      method: "PATCH",
      data: params,
    });
  },
  deleteLearning: (id) => {
    return HELPERS.secureRequest({
      url: `learning/` + id + `/`,
      method: "DELETE",
    });
  },
  // getFilters: () => {
  //     return HELPERS.request({
  //         url: `/activity/activity-filter-list/`,
  //         method: ‘GET’,
  //     });
  // },
  // createFilter: (data) => {
  //     return HELPERS.request({
  //         url: `/activity/create-activity-filter/`,
  //         method: ‘POST’,
  //         data: data
  //     });
  // },
  // getComments: (id) => {
  //     return HELPERS.request({
  //         url: `/activity/get-activity-notes/`,
  //         method: ‘GET’,
  //         params: { activity_id: id }
  //     });
  // },
  // getActivityDetails : (id) => {
  //     return HELPERS.request({
  //         url: `/activity/get-activity/${id}`,
  //         method: ‘GET’,
  //     });
  // },
  // getMilestones : (id) => {
  //     return HELPERS.request({
  //         url: `/activity/activity-milestone-list/`,
  //         method: ‘GET’,
  //         params: { activity_id: id }
  //     });
  // },
  // createMilestone : (data) => {
  //     return HELPERS.request({
  //         url: `/activity/insert-milestone/`,
  //         // url: `/activity/milestone-create/`,
  //         method: ‘POST’,
  //         data: data
  //     });
  // },
  // getMilestone : (id) => {
  //     return HELPERS.request({
  //         url: `/activity/get-milestone/${id}`,
  //         method: ‘GET’,
  //     });
  // },
  // updateActivity : (data) => {
  //     return HELPERS.request({
  //         url: `/activity/update-activity/${data.id}`,
  //         method: ‘PATCH’,
  //         data: data
  //     });
  // },
  // resolveConflict : (data) => {
  //     return HELPERS.request({
  //         url: `/activity/resolve-activity-conflict/${data.id}`,
  //         method: ‘PATCH’,
  //         data: data
  //     });
  // },
  // addComment : (data) => {
  //     return HELPERS.request({
  //         url: `/activity/create-activity-notes/`,
  //         method: ‘POST’,
  //         data: data
  //     });
  // },
  // closeMileStone : (data ,id) => {
  //     return HELPERS.request({
  //         url: `/activity/close-milestone/${id}`,
  //         method: ‘PATCH’,
  //         data: data
  //     });
  // },
  // deleteMilestone : (id) => {
  //     return HELPERS.request({
  //         url: `/activity/delete-milestone/${id}`,
  //         method: ‘DELETE’,
  //     });
  // },
  // createActivity : (data) => {
  //     console.log(‘in call’, data)
  //     return HELPERS.request({
  //         url: `/activity/activity-create/`,
  //         method: ‘POST’,
  //         data: data
  //     });
  // },
  // createActivityExtension :(data) => {
  //     return HELPERS.request({
  //         url: `/activity/create-activity-extension//`,
  //         method: ‘POST’,
  //         data: data
  //     });
  // },
  // deleteFilter: (id) => {
  //     return HELPERS.request({
  //         url: `/activity/activity-filter-delete/${id}/`,
  //         method: ‘DELETE’,
  //     });
  // },
  // closeActivity: (id) => {
  //     return HELPERS.request({
  //         url: `/activity/close-activity/${id}`,
  //         method: ‘PATCH’,
  //     });
  // },
  // fetchActivityMilestones: (id) => {
  //     return HELPERS.request({
  //         url: `/search/get-activity-milestone-list/`,
  //         method: ‘GET’,
  //         params: {
  //             activity_id: id
  //         }
  //     });
  // }
};
export default AUTH_API;
